import React, { useEffect, useState } from "react";
import { render } from "react-dom";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const HorizontalChart = (props) => {
  const [options, setOptions] = useState({});

  useEffect(() => {
    setOptions({
      chart: {
        type: "bar",
      },
      title: {
        text: "",
      },
      exporting: {
        enabled: false,
      },
      xAxis: {
        categories: [
          "<strong>Years Experience</strong>",
          "<strong>Qualification</strong>",
          "<strong>Courses</strong>",
          "<strong>Competency</strong>",
          "<strong>Skills</strong>",
        ],
        lineWidth: 0,
        minorGridLineWidth: 0,
        title: {
          text: null,
        },
        labels: {
          enabled: false,
        },
        tickWidth: 1,
        tickLength: 500,
        tickPosition: "inside",
        tickmarkPlacement: "on",
      },
      yAxis: {
        gridLineWidth: 0,
        minorGridLineWidth: 0,
        min: 0,
        title: {
          text: null,
        },
        labels: {
          enabled: false,
        },
      },
      tooltip: {
        enabled: true,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: false,
          },
        },
        series: {
          colorByPoint: true,
          colors: ["#e73f26", "#f59e0d", "#2bb4b0", "#2f9cca", "#26336e"],
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Score",
          data: props.data,
        },
      ],
    });
  }, [props]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ className: "equal-height-graph" }}
    />
  );
};

export default HorizontalChart;
